import React from "react";
import IconSfoglia from "../assets/sfoglia.svg";
import {withPrefix} from "gatsby";
import './../css/dflip/css/dflip.min.css';
import './../css/dflip/css/themify-icons.css';

export default class DpcSfogliatore extends React.Component {

    constructor(props) {
        super(props);
        if (typeof document !== `undefined`) {
            ['dflip/js/dflip.min.js'].forEach(item => {
                const script = document.createElement("script");
                script.src = withPrefix(item);
                script.async = false;
                script.id = item.split(".")[0] + '-js';
                document.body.appendChild(script);
            });
        }
    }
    getTitle = () => {
        if (typeof window !== "undefined")
            return window.location.pathname.split("/")[1] === 'it' ? 'Sfoglia' : 'Sfoglia';
    }

    render() {
        return (
            <>
                {this.props.isEmbed ? 
                    <div className={"_df_book"} id="flipbok_example" source={this.props.url}></div>
                    :
                <li>               
                    <div className={"_df_button"} id="flipbok_example" source={this.props.url}>
                        <IconSfoglia/>
                        <span>{this.getTitle()}</span>
                    </div>
                    
                </li>
                }
            </>
        );
    }
}
